import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { GenericDocLineContainerModel, GenericDocLineRecentItemDto } from '../../../../../../models';
import { ApiResponseModel, ApiVisa, Pagination, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';
import { LandedCostsDtoModel } from '../../../data-transfer-objects';

@Injectable({ providedIn: 'root' })

export class GenericDocLineService extends BaseApiTemplateService<GenericDocLineContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/lines';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/lines';
    this.httpClient = http;
  }

  getLinesByCriteria(doctype, pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
    }
    const UrlByCriteria = this.apiUrl + '/' + doctype + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocLineContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  setLandingCost(dtoObject: LandedCostsDtoModel[], visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/set-landing-cost/backoffice-ep';
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getRecentGenericDocLines(doctype:String, inputDto: GenericDocLineRecentItemDto, visa: ApiVisa): Observable<PagingResponseModel<GenericDocLineContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + doctype + '/backoffice-ep/recent-item-lines?' + inputDto.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<GenericDocLineContainerModel>>(this.apiUrl, this.getHttpHeader(visa));
  }

  public getByCriteriaLoginConsolidatedArap(
    pagination: Pagination,
    visa: ApiVisa,
  ): Observable<PagingResponseModel<GenericDocLineContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.LOGIN_CONSOLIDATED_ARAP_EP_SUFFIX;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocLineContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
